package us.laantech.common.util


fun String.to5dp(): Long {
    requireNotNull(this.toDoubleOrNull()) {
        "Tax rate must be a number"
    }

    val parts = this.split(".")
    val wholePart = parts[0]
    val decimalPart = if (parts.size > 1) parts[1] else "0"

    // force 5-digit precision Long format
    val a = wholePart.toLong() * 100_000L
    val b = decimalPart.take(5).padEnd(5, '0').toLong()

    val taxRate5dp = a + b

    return taxRate5dp
}

fun Long.from5dp(): String {
    val wholePart = this / 100_000L
    val decimalPart = this % 100_000L
    return "$wholePart.${decimalPart.toString().padStart(5, '0')}"
}